import React from 'react';
import styled from 'styled-components';
import sx from '../../sx.js';
import Box from '../Box/Box.js';
import { get } from '../../constants.js';

/**
 * The Getting Started page's SurfaceCardGrid component accepts a `children` prop, which you can use to pass in SurfaceCard components to display in a grid.
 *
 * It will display cards in a horizontal grid at 768px and above, then display in a column below 768px.
 *
 */
const SurfaceCardGrid = ({
  as = 'ul',
  children,
  sx: sxProp
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, {
    sx: sxProp
  }, /*#__PURE__*/React.createElement(Grid, {
    as: as
  }, children));
};
SurfaceCardGrid.displayName = "SurfaceCardGrid";
const Wrapper = styled(Box).withConfig({
  displayName: "SurfaceCardGrid__Wrapper",
  componentId: "sc-1fpl56s-0"
})(["margin:0 auto;width:100%;padding:", ";display:flex;align-items:center;justify-content:center;@media (min-width:", "){}@media (min-width:", "){}", ""], get('space.2'), get('breakpoints.1'), get('breakpoints.2'), sx);
const Grid = styled(Box).withConfig({
  displayName: "SurfaceCardGrid__Grid",
  componentId: "sc-1fpl56s-1"
})(["display:flex;flex-wrap:wrap;justify-content:center;list-style:none;padding-left:0;gap:", ";@media (min-width:", "){}@media (min-width:", "){}@media (min-width:", "){}@media (min-width:", "){}"], get('space.4'), get('breakpoints.0'), get('breakpoints.1'), get('breakpoints.2'), get('breakpoints.3'));
SurfaceCardGrid.displayName = 'SurfaceCardGrid';
var SurfaceCardGrid$1 = SurfaceCardGrid;

export { SurfaceCardGrid$1 as default };
